import { render, staticRenderFns } from "./ListaClientes.vue?vue&type=template&id=7d7aa002&scoped=true"
import script from "./ListaClientes.vue?vue&type=script&lang=js"
export * from "./ListaClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7aa002",
  null
  
)

export default component.exports